import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
const LogOut = () => {
  const { logoutLink } = useSelector((state) => state.navigation);
  return (
    <Fragment>
      {logoutLink && logoutLink.href && (
        <a className='logout-btn' href={logoutLink.href}> {translate('logout.logout')} </a>
      )}
    </Fragment>
  );
};

export default LogOut;
